import type { FC } from "react";
import { IoArrowBackCircle } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { PublicHeaderContainer } from "./public-header.style";
import { IPublicHeaderProps } from "./types";

export const PublicHeader: FC<IPublicHeaderProps> = ({ title, icon }) => {
  const navigate = useNavigate();

  return (
    <PublicHeaderContainer>
      <div className="public_header_right_section">
        {icon}
        <p className="public_header_title">{title}</p>
      </div>
      <div onClick={() => navigate(-1)} className="back_container">
        <p>بازگـشت</p>
        <IoArrowBackCircle size={28} className="back_icon" />
      </div>
    </PublicHeaderContainer>
  );
};
